import React, { ReactElement } from "react";

interface AccordionItemProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  titleIcon?: string;
  expandAll?: boolean;
}

interface CustomAccordionProps {
  children:
    | ReactElement<AccordionItemProps>
    | ReactElement<AccordionItemProps>[];
  containerClass?: string;
  expandAll?: boolean;
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  children,
  containerClass,
  expandAll = false,
}) => {
  const clonedChildren = React.Children.map(children, (child) =>
    React.cloneElement(child, { expandAll }),
  );

  return <div className={containerClass}>{clonedChildren}</div>;
};

export default CustomAccordion;
